import { Link } from 'react-router-dom'
import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'
import { services } from '../../data/services'

export function ServicesOverview() {
  return (
    <section className="border-b border-ink/10 py-24 md:py-32">
      <Container>
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <Eyebrow>Services</Eyebrow>
            <h2 className="mt-6 max-w-xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              What we build.
            </h2>
          </Reveal>
          <Reveal delay={100}>
            <CTA to="/services" variant="ghost">
              Explore services
            </CTA>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-ink/10 bg-ink/10 md:grid-cols-2">
          {services.map((service, i) => (
            <Reveal key={service.slug} delay={i * 60}>
              <Link
                to={`/services/${service.slug}`}
                className="group flex h-full flex-col justify-between gap-8 bg-paper p-8 transition-colors duration-300 hover:bg-bone md:p-10"
              >
                <div className="flex items-start justify-between">
                  <h3 className="font-display text-2xl font-semibold tracking-tight">{service.name}</h3>
                  <span className="text-xl text-ink/30 transition-all duration-300 group-hover:translate-x-1 group-hover:text-signal">
                    →
                  </span>
                </div>
                <p className="max-w-sm text-sm leading-relaxed text-graphite">{service.tagline}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}
